import React from 'react';
import BarChartIcon from '@material-ui/icons/BarChart';
import { useLocation } from 'react-router-dom';

import { STSNavItem } from './STSNavItem';

const INSIGHTS_PATHS = [
  '/finops/dashboard',
  '/finops/bu-insights',
  '/finops/anomalies',
  '/finops/chargeback',
  '/finops/ai-tools',
];

export const FinOpsNav = () => {
  const location = useLocation();

  const isInsightsActive = INSIGHTS_PATHS.some(p =>
    location.pathname.startsWith(p),
  );
  const [insightsExpanded, setInsightsExpanded] = React.useState(true);

  React.useEffect(() => {
    if (isInsightsActive) {
      setInsightsExpanded(true);
    }
  }, [isInsightsActive]);

  return (
    <STSNavItem
      icon={BarChartIcon}
      text="Insights"
      expandable
      isExpanded={insightsExpanded}
      onToggle={() => setInsightsExpanded(prev => !prev)}
    >
      <STSNavItem text="Dashboard" to="finops/dashboard" isSubItem />
      <STSNavItem text="BU Insights" to="finops/bu-insights" isSubItem />
      <STSNavItem
        text="Comparison & Anomalies"
        to="finops/anomalies"
        isSubItem
      />
      <STSNavItem text="Chargeback" to="finops/chargeback" isSubItem />
      <STSNavItem text="AI Tools & Frameworks" to="finops/ai-tools" isSubItem />
    </STSNavItem>
  );
};
